import { put, takeLatest } from "redux-saga/effects";
import { getDataCalculateCartApi } from "store/api/OrderApi";
import { GET_DATA_CALCALATE_CART_ACTION } from "../../actions/OrderPageAction/actionTypes";

import * as orderPageAction from "../../actions/OrderPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getDataCalculateCart(action) {
	const res = yield getDataCalculateCartApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(orderPageAction.setDataCalculateCartAction(res?.data));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getDataCalculateCartSaga() {
	yield takeLatest(GET_DATA_CALCALATE_CART_ACTION, getDataCalculateCart);
}

export default getDataCalculateCartSaga;
